export const APPOINTLY_PROD_SLUG = 'johannes-rekowski-discovery-meeting-2872'

export const APPOINTLY_NON_PROD_SLUG = 'gokay-test37-termin-mit-gokay-test37'
